import api from "../services/api-service";

class QuizFixByAi {
  getTagQuestions() {
    try {
      return api.get({
        url: "tag/get-tag-questions-count",
      });
    } catch (error) {
      return new Error(error);
    }
  }

  getCourseQuizzesCount(instructorId) {
    try {
      return api.get({
        url: `quiz/get-untagged-questions-count?instructor_id=${instructorId}`,
      });
    } catch (error) {
      return new Error(error);
    }
  }

  startAIValidation(payload) {
    try {
      return api.post({
        url: "ai-validation/start",
        body: payload
      });
    } catch (error) {
      return new Error(error);
    }
  }

  getAllSubmissions(moduleTagId, instructorId) {
    try {
      return api.get({
        url: `ai-validation/get-all-submissions?module_tag_id=${moduleTagId}&instructor_id=${instructorId}`
      });
    } catch (error) {
      return new Error(error);
    }
  }

  getQuizSubmissions(quizId, instructorId) {
    try {
      return api.get({
        url: `ai-validation/get-all-submissions?quiz_id=${quizId}&instructor_id=${instructorId}`
      });
    } catch (error) {
      return new Error(error);
    }
  }

  getSubmissionDetails(submissionId) {
    try {
      return api.get({
        url: `ai-validation/get-submission-details/${submissionId}`
      });
    } catch (error) {
      return new Error(error);
    }
  }

  cleanQuizQuestions(payload) {
    try {
      return api.post({
        url: "ai-validation/clean-quiz-questions",
        body: payload
      });
    } catch (error) {
      return new Error(error);
    }
  }

   abortBatch(batchId) {
    try {
      return api.post({
        url: `ai-validation/abort/${batchId}`,
      });
    } catch (error) {
      return new Error(error);
    }
  }
}
export default new QuizFixByAi();
